import { toast } from "react-toastify";

const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

const API_BASE_URL = trimTrailingSlash(
    process.env.REACT_APP_API_BASE_URL || "http://localhost:3030/api"
);
const MEDIA_BASE_URL = trimTrailingSlash(
    process.env.REACT_APP_MEDIA_BASE_URL || API_BASE_URL.replace(/\/api$/, "")
);

let authErrorToastShown = false;

export const clearAdminSession = () => {
    localStorage.removeItem("premierChefAdminAuthenticated");
    localStorage.removeItem("premierChefAdminToken");
    localStorage.removeItem("premierChefAdmin");
};

export const fetchAPI = async (endpoint, options = {}) => {
    const isFormData = options.body instanceof FormData;
    const token = localStorage.getItem('premierChefAdminToken');
    const headers = {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
    };

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        if (response.status === 401 && endpoint !== "/admin/login") {
            clearAdminSession();
            if (!authErrorToastShown) {
                authErrorToastShown = true;
                toast.error(errorData.message || "Your admin session expired. Please login again.", {
                    toastId: "admin-auth-expired",
                    autoClose: 3500,
                });
                setTimeout(() => {
                    authErrorToastShown = false;
                }, 4000);
            }
            const authError = new Error(errorData.message || "Invalid authentication token");
            authError.isAuthError = true;
            throw authError;
        }
        throw new Error(errorData.message || 'Network response was not ok');
    }

    return response.json();
};

export const getMediaUrl = (url = '') => {
    if (!url) return '';
    if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url;
    return `${MEDIA_BASE_URL}${url.startsWith('/') ? url : `/${url}`}`;
};
